import { render, staticRenderFns } from "./PageLoad.vue?vue&type=template&id=3a096f5f&scoped=true&"
import script from "./PageLoad.vue?vue&type=script&lang=ts&"
export * from "./PageLoad.vue?vue&type=script&lang=ts&"
import style0 from "./PageLoad.vue?vue&type=style&index=0&id=3a096f5f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a096f5f",
  null
  
)

export default component.exports